import { render, staticRenderFns } from "./accounting-user-credits.vue?vue&type=template&id=15ffe46e&"
import script from "./accounting-user-credits.vue?vue&type=script&lang=js&"
export * from "./accounting-user-credits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports